import { render, staticRenderFns } from "./OrderCreateModal.vue?vue&type=template&id=3f215304&"
import script from "./OrderCreateModal.vue?vue&type=script&lang=js&"
export * from "./OrderCreateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports